import React from "react";
import { Grid, TextField, InputAdornment } from "@mui/material";
import { EmailOutlined as EmailIcon, PhoneOutlined as PhoneIcon } from "@mui/icons-material";

interface ContactBasicInfoFieldsProps {
  formData: {
    firstName: string;
    surname: string;
    email: string;
    phone: string;
  };
  onChange: (section: string | null, field: string, value: any) => void;
}

const ContactBasicInfoFields: React.FC<ContactBasicInfoFieldsProps> = ({ formData, onChange }) => (
  <>
    <Grid item xs={6}>
      <TextField
        label="First Name"
        required
        fullWidth
        value={formData.firstName}
        onChange={(e) => onChange(null, "firstName", e.target.value)}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        label="Last Name"
        fullWidth
        value={formData.surname}
        onChange={(e) => onChange(null, "surname", e.target.value)}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        label="Email Address"
        type="email"
        placeholder="user@example.com"
        fullWidth
        value={formData.email}
        onChange={(e) => onChange(null, "email", e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EmailIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        label="Phone Number (Mobile)"
        type="tel"
        placeholder="(555) 555-5555"
        fullWidth
        value={formData.phone}
        onChange={(e) => onChange(null, "phone", e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PhoneIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  </>
);

export default ContactBasicInfoFields;
